import { ProgressCircle } from '@adobe/react-spectrum';
import React, { useEffect, useRef } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

import { useStore } from '../../store';

const TotalResults = ({ loading, totalApps, productsLocs }) => {
  const cloud = useStore((state) => state.cloud);
  const [searchParams] = useSearchParams();
  const searchResultsRef = useRef(null);
  const timesSearchResultsLoaded = useRef(0);
  const shouldScrollToSearchResults = useRef(false);
  const location = useLocation();
  const product = searchParams.get('product');

  useEffect(() => {
    shouldScrollToSearchResults.current = true;
  }, [location.search]);

  useEffect(() => {
    shouldScrollToSearchResults.current = false;
  }, [product]);

  useEffect(() => {
    if (loading) {
      timesSearchResultsLoaded.current++;
    }
    if (
      searchResultsRef.current?.offsetTop < window.scrollY &&
      timesSearchResultsLoaded.current > 1 &&
      loading &&
      shouldScrollToSearchResults.current
    ) {
      window.scrollTo(0, searchResultsRef.current.offsetTop);
      shouldScrollToSearchResults.current = false;
    } else if (timesSearchResultsLoaded.current > 1 && loading && !shouldScrollToSearchResults.current) {
      window.scrollTo(0, 0);
    }
  }, [location.search, loading]);

  const resultsText = ` result${totalApps !== 1 ? 's' : ''}`;
  const productText = productsLocs?.get(product)?.label ?? product;
  const ccText = cloud !== 'cc' && (
    <>
      &nbsp;in
      <strong> {productText}</strong>
    </>
  );

  return (
    <p ref={searchResultsRef} data-launchid="total-results" aria-live="polite" aria-atomic={true}>
      {loading ? (
        <span>
          <ProgressCircle isIndeterminate size="S" aria-label="Loading" marginBottom="-4px" /> {resultsText}
          {ccText}
        </span>
      ) : (
        <span>
          {totalApps} {resultsText}
          {ccText}
        </span>
      )}
    </p>
  );
};

export default TotalResults;
